// MachineUtilizationDashboard/components/DepartmentUtilizationChart.jsx

import Chart from "react-apexcharts";
import {
  formatNumber,
  truncateText,
} from "../utils/machineDashboardUtils";

function DepartmentUtilizationChart({ data = [] }) {
  const departments = Array.isArray(data) ? data : [];

  const chartOptions = {
    chart: {
      type: "bar",
      stacked: false,
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      parentHeightOffset: 0,
    },

    plotOptions: {
      bar: {
        borderRadius: 6,
        columnWidth: "50%",
      },
    },

    colors: ["#053c83"],

    dataLabels: {
      enabled: false,
    },

    xaxis: {
      categories: departments.map((item) =>
        truncateText(item?.deptName || item?.deptCode || "-", 17),
      ),

      labels: {
        rotate: -45,
        trim: true,

        style: {
          colors: "#64748b",
          fontSize: "12px",
        },
      },
    },

    yaxis: {
      min: 0,

      labels: {
        formatter: (value) => `${formatNumber(value)}%`,

        style: {
          colors: "#64748b",
          fontSize: "10px",
        },
      },

      title: {
        text: "Utilization %",
        style: {
          color: "#64748b",
          fontSize: "11px",
          fontWeight: 600,
        },
      },
    },

    grid: {
      borderColor: "#edf2f7",
      strokeDashArray: 4,
    },

    tooltip: {
      custom: ({ dataPointIndex }) => {
        const department = departments[dataPointIndex];

        if (!department) return "";

        return `
          <div class="mud-chart-tooltip">
            <strong>${department.deptCode || ""}</strong>
            <span>${department.deptName || "-"}</span>
            <span>Machines: ${formatNumber(department.totalMachines)}</span>
            <span>Running: ${formatNumber(department.runningMachines)}</span>
            <span>Production: ${formatNumber(department.totalProduction)}</span>
            <b>${formatNumber(department.utilizationPercentage, 2)}%</b>
          </div>
        `;
      },
    },
  };

  const series = [
    {
      name: "Utilization",
      data: departments.map((item) =>
        Number(item?.utilizationPercentage || 0),
      ),
    },
  ];

  if (departments.length === 0) {
    return (
      <div className="mud-empty-state">No department data available.</div>
    );
  }

  return (
    <Chart
      key={`departments-${departments
        .map((item) => item.deptCode)
        .join("-")}`}
      options={chartOptions}
      series={series}
      type="bar"
      height={390}
    />
  );
}

export default DepartmentUtilizationChart;